import { FC } from 'react';
import {
    BulkAddProductsToSelectionListResponse,
    BulkAddProductsToShoppingCartResponse,
    BundleOut
} from '../../store/api';
import { PriceTier } from '../../../models/PriceTier';
import { SelectionList } from '../../../models/SelectionList';
import { BundleHeader } from './BundleHeader';
import { isEmptyProductFilters, useProductFilters } from '../filter/useProductFilters';
import { SubscriptionPeriodType } from '../../../models/Article';

type Props = {
    readonly bundle: (BundleOut & { price?: number }) | undefined;
    readonly selectionList?: SelectionList;
    readonly selectionLists: ReadonlyArray<SelectionList>;
    readonly onAddBundleToList: (
        orderList: SelectionList,
        priceTier: PriceTier,
        subscriptionPeriodType: SubscriptionPeriodType,
        performChecks: boolean
    ) => Promise<BulkAddProductsToSelectionListResponse>;
    readonly onAddBundleToCart: (
        priceTier: PriceTier,
        subscriptionPeriodType: SubscriptionPeriodType,
        performChecks: boolean
    ) => Promise<BulkAddProductsToShoppingCartResponse>;
    readonly onCreateNewListClicked?: (newListName: string) => void;
};

const DetailHeader: FC<Props> = ({
    onAddBundleToList,
    onAddBundleToCart,
    bundle,
    selectionLists,
    onCreateNewListClicked
}) => {
    const { productFilter } = useProductFilters();

    return (
        <BundleHeader
            bundle={bundle}
            filtered={!isEmptyProductFilters(productFilter)}
            onAddBundleToList={onAddBundleToList}
            onAddBundleToCart={onAddBundleToCart}
            onCreateNewListClicked={onCreateNewListClicked}
            selectionLists={selectionLists}
        />
    );
};

export default DetailHeader;
